import React from 'react';

const MaterialIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4136_233)">
            <g clipPath="url(#clip1_4136_233)">
                <path
                    d="M16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3Z"
                    stroke="#323232"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="7" cy="7" r="0.75" fill="#323232" />
                <circle cx="12" cy="7" r="0.75" fill="#323232" />
                <circle cx="17" cy="7" r="0.75" fill="#323232" />
                <circle cx="9.5" cy="9.5" r="0.75" fill="#323232" />
                <circle cx="14.5" cy="9.5" r="0.75" fill="#323232" />
                <circle cx="14.5" cy="9.5" r="0.75" fill="#323232" />
                <circle cx="7" cy="12" r="0.75" fill="#323232" />
                <circle cx="12" cy="12" r="0.75" fill="#323232" />
                <circle cx="17" cy="12" r="0.75" fill="#323232" />
                <circle cx="9.5" cy="14.5" r="0.75" fill="#323232" />
                <circle cx="14.5" cy="14.5" r="0.75" fill="#323232" />
                <circle cx="7" cy="17" r="0.75" fill="#323232" />
                <circle cx="12" cy="17" r="0.75" fill="#323232" />
                <circle cx="17" cy="17" r="0.75" fill="#323232" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4136_233">
                <rect width="24" height="24" fill="white" />
            </clipPath>
            <clipPath id="clip1_4136_233">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default MaterialIcon;
